<!--
    Parent component of Block. Use this if you want to display a set of blocks next to each other.
 -->

<template>
    <div :class="`c-block-group ${spacing ? `c-block-group--${spacing}` : ''} ${customClass ? customClass : ''}`">
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Block from './Block'

    // Register subcomponents
    Vue.component('v-block', Block);

    export default {
        props: ['custom-class', 'spacing']
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-block-group {
        > * {
            &:not(:last-child) {
                margin-bottom: 2px;
            }
        }
    }

    .c-block-group--small {
        > * {
            &:not(:last-child) {
                margin-bottom: em($global-spacing-unit-small);
            }
        }
    }

    .c-block-group--tiny {
        > * {
            &:not(:last-child) {
                margin-bottom: em($global-spacing-unit-tiny);
            }
        }
    }

    .c-block-group--none {
        > * {
            &:not(:last-child) {
                margin-bottom: 0;
            }
        }
    }

</style>

<style lang="scss">
    .c-block-group--horizontal {
        .c-block-wrapper {
            height: 100%;

            &:not(:last-child) {
                .c-block{
                    padding-bottom: 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/blocks/Blocks.vue